var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "batch-setting-log" },
    [
      _c(
        "div",
        { staticClass: "search-area" },
        [
          _c(
            "el-form",
            {
              staticClass: "search-form",
              attrs: { inline: true, model: _vm.searchForm },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "批次号" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "180px" },
                    attrs: { placeholder: "批次号", clearable: "" },
                    model: {
                      value: _vm.searchForm.batchNo,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "batchNo", $$v)
                      },
                      expression: "searchForm.batchNo",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "门店名称" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "180px" },
                    attrs: { placeholder: "门店名称", clearable: "" },
                    model: {
                      value: _vm.searchForm.storeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "storeName", $$v)
                      },
                      expression: "searchForm.storeName",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "操作类型" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "150px" },
                      attrs: { placeholder: "选择操作类型", clearable: "" },
                      model: {
                        value: _vm.searchForm.operationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "operationType", $$v)
                        },
                        expression: "searchForm.operationType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "推送设置", value: "推送设置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "开票配置", value: "开票配置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "外卖运费设置", value: "外卖运费设置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "营业时间配置", value: "营业时间配置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "周期运费配置", value: "周期运费配置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "公告设置", value: "公告设置" },
                      }),
                      _vm._v(" "),
                      _c("el-option", {
                        attrs: { label: "福利社图片", value: "福利社图片" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "操作结果" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "120px" },
                      attrs: { placeholder: "选择结果", clearable: "" },
                      model: {
                        value: _vm.searchForm.operationResult,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "operationResult", $$v)
                        },
                        expression: "searchForm.operationResult",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "成功", value: 1 } }),
                      _vm._v(" "),
                      _c("el-option", { attrs: { label: "失败", value: 0 } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("搜索")]
                  ),
                  _vm._v(" "),
                  _c("el-button", { on: { click: _vm.resetSearch } }, [
                    _vm._v("重置"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: { data: _vm.tableData, stripe: "", border: "" },
        },
        [
          _c("el-table-column", {
            attrs: {
              type: "index",
              label: "序号",
              width: "60",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "batchNo",
              label: "批次号",
              width: "180",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "storeName",
              label: "门店名称",
              width: "150",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operationType",
              label: "操作类型",
              width: "250",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._l(
                      _vm.getOperationTypes(scope.row.operationType),
                      function (type, index) {
                        return _c(
                          "el-tag",
                          {
                            key: index,
                            staticStyle: { margin: "2px" },
                            attrs: {
                              size: "small",
                              type: _vm.getOperationTagType(type),
                            },
                          },
                          [_vm._v("\n          " + _vm._s(type) + "\n        ")]
                        )
                      }
                    ),
                    _vm._v(" "),
                    !scope.row.operationType
                      ? _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ])
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { label: "修改内容", "min-width": "150", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "text",
                          size: "small",
                          disabled: !scope.row.newValue && !scope.row.oldValue,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.showDetailDialog(scope.row)
                          },
                        },
                      },
                      [_vm._v("\n          查看详情\n        ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operationResult",
              label: "操作结果",
              width: "100",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type:
                            scope.row.operationResult === 1
                              ? "success"
                              : "danger",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              scope.row.operationResult === 1 ? "成功" : "失败"
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "errorMsg",
              label: "错误信息",
              "min-width": "150",
              align: "center",
              "show-overflow-tooltip": "",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.errorMsg
                      ? _c("span", { staticStyle: { color: "#f56c6c" } }, [
                          _vm._v(_vm._s(scope.row.errorMsg)),
                        ])
                      : _c("span", { staticStyle: { color: "#909399" } }, [
                          _vm._v("-"),
                        ]),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "operatorName",
              label: "操作人",
              width: "120",
              align: "center",
            },
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "操作时间",
              width: "160",
              align: "center",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.formatDateTime(scope.row.createTime)) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              prop: "ipAddress",
              label: "IP地址",
              width: "120",
              align: "center",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-pagination", {
        staticStyle: { "margin-top": "20px", "text-align": "right" },
        attrs: {
          "current-page": _vm.page,
          "page-sizes": [10, 20, 50, 100],
          "page-size": _vm.limit,
          layout: "total, sizes, prev, pager, next, jumper",
          total: _vm.total,
        },
        on: {
          "size-change": _vm.handleSizeChange,
          "current-change": _vm.handleCurrentChange,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量设置详情",
            visible: _vm.detailDialogVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.currentRow
            ? _c("div", { staticClass: "detail-content" }, [
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("批次号：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentRow.batchNo)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("门店：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentRow.storeName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("操作类型：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentRow.operationType || "-")),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("操作人：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(_vm._s(_vm.currentRow.operatorName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "detail-row" }, [
                  _c("span", { staticClass: "label" }, [_vm._v("操作时间：")]),
                  _vm._v(" "),
                  _c("span", { staticClass: "value" }, [
                    _vm._v(
                      _vm._s(_vm.formatDateTime(_vm.currentRow.createTime))
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _vm.currentRow.oldValue || _vm.currentRow.newValue
                  ? _c("div", { staticClass: "diff-section" }, [
                      _c("div", { staticClass: "diff-title" }, [
                        _vm._v("修改内容对比："),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "diff-content" }, [
                        _vm.currentRow.oldValue
                          ? _c("div", { staticClass: "diff-item" }, [
                              _c("div", { staticClass: "diff-label" }, [
                                _vm._v("修改前："),
                              ]),
                              _vm._v(" "),
                              _c("pre", { staticClass: "diff-value old" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatJson(_vm.currentRow.oldValue)
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentRow.newValue
                          ? _c("div", { staticClass: "diff-item" }, [
                              _c("div", { staticClass: "diff-label" }, [
                                _vm._v("修改后："),
                              ]),
                              _vm._v(" "),
                              _c("pre", { staticClass: "diff-value new" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.formatJson(_vm.currentRow.newValue)
                                  )
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.detailDialogVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }